import {UIService} from "../components/UIService";
import {ApiService} from "./apiService";
import {PriceStore} from "../stores/priceStore";
import {ApiDataService} from "./apiDataService";
import {EventService} from "./eventService";
import {MarketService} from "./marketService";

export class PriceService {
    private uiService: UIService;
    private apiDataService: ApiDataService;
    private apiService: ApiService;
    private priceStore: PriceStore;
    private eventService: EventService;
    private market: MarketInterface;

    constructor() {
        this.apiDataService = new ApiDataService();
        this.uiService = new UIService();
        this.apiService = new ApiService();
        this.priceStore = new PriceStore();
        this.eventService = new EventService();
        this.market = new MarketService().getCurrent();
    }

    recalculatePrice() {
        const data = this.apiDataService.getDataForCalculatePriceApiCall();
        const priceModule = Array.from(this.uiService.getElementsByClassName('priceModule'));
        const quantity = data.data[0].attributes.quantity;

        priceModule.forEach((element) => {
            element.classList.add('--loading');
        });
        this.apiService.getPrice(data).then((response) => {
            if (response.data) {
                this.priceStore.set(response.data);
                this.recalculatePriceBasedOnQuantity(quantity);

                priceModule.forEach((element) => {
                    element.classList.remove('--loading');
                });

                this.eventService.emit('updateColorPrices');
                this.eventService.emit('updatePacketPrices');
                this.eventService.emit('updateAccessoriesPrices');
            } else {
                this.uiService.updatePriceModule({
                    price: 0,
                    netPrice: 0,
                });

                priceModule.forEach((element) => {
                    element.classList.remove('--loading');
                });
            }
        });
    }

    recalculatePriceBasedOnQuantity(quantity)
    {
        quantity = Number.parseInt(quantity);

        const priceObject = this.priceStore.get()[0];
        const recalculatedPriceObject = {
            price: priceObject.price * quantity,
            netPrice: priceObject.netPrice * quantity,
            discount: priceObject.discount * quantity,
            netDiscount: priceObject.netDiscount * quantity,
            discountValueForRegularCustomer: priceObject.discountValueForRegularCustomer * quantity,
        };
        this.uiService.updatePriceModule(recalculatedPriceObject);
    }

    calculateNetPrice(price)
    {
        const vatRate = this.market.get().taxPercentage;

        return (1 - vatRate) * price;
    }
}
